import Result from 'antd/lib/result'

import 'antd/lib/result/style'

export * from 'antd/lib/result'

export default Result
